
import React, { useState } from 'react'

import { Upload, Button, message, Form } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import axios from 'axios';
import './style.css'
const FileBox = ({name,label,rules, max, focus}) => {
  const [valid, setvalid] = useState(true)
  const props = {
    name: 'file',
    action: `${process.env.REACT_APP_API_BASE_URL}/client/file/upload`,
    headers: {
      authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    
    
    onRemove: (file) => {
      const res = axios (`${process.env.REACT_APP_API_BASE_URL}/client/file/delete`,
      {
          headers: {
              'content-type': 'application/json',
              'authorization': `Bearer ${localStorage.getItem("token")}`
          },
          data: {
            file: file?.response?.name,
          },
          method: 'delete'
      
      })
  },
  };
  function beforeUpload(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.addEventListener('load', event => {
      const _loadedImageUrl = event.target.result;
      const image = document.createElement('img');
      image.src = _loadedImageUrl;
      image.onload = function() {
        if(this.width > 120 && this.height > 120){
          setvalid(false)
        }
        else{
          setvalid(true)
        }
    }
// console.log(image)
      // image.addEventListener('load', () => {
      //   const { width, height } = image;
      //   if(width > 120 && height > 120){
         
      //     setvalid(false)
      //     return 
      //   }
      // });

    });
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    
    if (!isJpgOrPng) {
      message.error('You can only upload image file!');
      return
    }
    // const isLt2M = file.size / 120 / 120 < 1;
    
    // if (!isLt2M) {
    //   message.error('Image must smaller than 1MB!');
    // }
    
    // if(!valid){
    //   message.error('Image size should be 125/125');
    // }
    // console.log(valid)
    return (isJpgOrPng);
  }
  const handleChange = async info => {
    let a = info.fileList[0].thumbUrl
    info.fileList[0].thumbUrl.onload = function() {
      alert(this.width + 'x' + this.height);
    }

  };
  return ( 
    <Form.Item
    style={{borderRadius: '5px',textAlign: 'center',display: 'flex', justifyContent: 'center'}}
    
    name={name}
    rules={rules}
    >
      <Upload {...props} 
        className="avatar-uploader"
        listType="picture"
        maxCount={max  ? max : 1} 
        beforeUpload={beforeUpload}
      // onChange={(e) => handleChange(e)}
      >
        <Button icon={<UploadOutlined />} style={{ display: 'flex', justifyContent: 'center'}}>{label}</Button>
      </Upload>
    </Form.Item>

   );
}
 
export default FileBox;